<template>
  <div class="index-panel" v-show="value">
    <div :class="device === 'mobile' ? 'mobile-index-contain' : 'index-contain'">
      <div class="index-bg" v-if="device !== 'mobile'" />
      <div class="index-right index-input">
        <div class="right-header">
          <i class="el-icon-close" @click="handleClose"></i>
          <i v-show="currPanelType === 'forget'" class="el-icon-back" @click="changePanelFunc('login')"></i>
        </div>
        <loginPanel
            v-if="currPanelType === 'login'"
            :isMobile="device"
            @changePanel="changePanelFunc"
            @successFunc="handleClose"
        />
        <registerPanel
            v-else-if="currPanelType === 'register'"
            :isMobile="device"
            @changePanel="changePanelFunc"
            @handleClose="handleClose"
        />
        <forgetPanel
            v-else-if="currPanelType === 'forget'"
            :isMobile="device"
        />
        <wechatLogin
            v-else
            :isMobile="device"
            @changePanel="changePanelFunc"
        />
      </div>
    </div>
  </div>
</template>

<script>
import loginPanel from './loginPanel.vue'
import registerPanel from './registerPanel.vue'
import forgetPanel from './forgetPanel.vue'
import wechatLogin from './wechatLogin.vue'

export default {
  name: 'indexPanel',
  computed: {
    device() {
      return this.$store.state.app.device
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    currDevice: {
      type: String
    },
    panelType: ''
  },
  components: {
    loginPanel,
    registerPanel,
    forgetPanel,
    wechatLogin
  },
  watch: {
    value(val) {
      if (!val) {
        this.currPanelType = 'login'
      } else {
        this.currPanelType = this.panelType
      }
    }
  },
  data() {
    return {
      changePanel: true,
      currPanelType: ''
    }
  },
  mounted() {
    this.currPanelType = this.panelType
    if (this.device !== 'mobile') {
      const {width} = window.screen
      if (width <= 1500) {
        console.log(width)
        console.log(document.querySelectorAll('.index-contain'))
        document.querySelector('.index-contain').style.transform = 'translateY(-50%) scale(0.85)'
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    changePanelFunc(val) {
      this.currPanelType = val
    }
  }
}
</script>

<style lang="scss" scoped>
.index-panel {
  position: fixed;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: center;

  .index-contain {
    position: relative;
    display: inline-block;
    height: p2r(600px);
    top: 50%;
    transform: translateY(-50%);
    text-align: left;

    .index-bg {
      width: p2r(480px);
      height: 100%;
      background: url("../../assets/img/login/login_bg.jpg") no-repeat;
      background-size: contain;
      box-sizing: border-box;
      padding: 80px 40px;
      color: #ffffff;


      p {
        &:nth-of-type(1) {
          font-size: 36px;
          margin-bottom: 40px;
        }
      }

      .center-desc-text {
        text-align: center;
        line-height: 1.8;
        font-size: 30px;
        margin-top: 100px;
        letter-spacing:2px;
      }


    }

    .index-input {
      width: p2r(480px);
      height: 100%;
      background: white;
    }

    .index-right {
      .right-header {
        font-size: 32px;
        padding: p2r(13px);
        color: #cccccc;
        cursor: pointer;
        margin-bottom: p2r(30px);
        display: flex;
        flex-flow: row-reverse;
        justify-content: space-between;
        align-items: center;
      }
    }

    .index-bg, .index-input {
      float: left;
    }
  }

  .mobile-index-contain {
    position: relative;
    display: inline-block;
    min-height: p2r(380px);
    text-align: left;
    top: 50%;
    transform: translateY(-50%);

    .index-input {
      width: p2r(320px);
      height: 100%;
      background: white;
    }

    .index-right {
      .right-header {
        font-size: p2r(24px);
        padding: p2r(3.5px);
        color: #cccccc;
        cursor: pointer;
        margin-bottom: p2r(12.5px);
        display: flex;
        flex-flow: row-reverse;
        justify-content: space-between;
        align-items: center;
      }
    }

    .index-bg, .index-input {
      float: left;
    }
  }

  .index-left-top {
    display: flex;
    align-items: center;
  }

  .index-panel-logo {
    height: p2r(60px);
    width: auto;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginPanel/indexPanel.vue